import request from 'utils/request'
import {format} from 'utils'
import api from 'common/api/group'

export async function getGroupMembers(payload) {
    return request(`${format(api.getGroupMembers.url, {id: payload.id})}`, {
        method: api.getGroupMembers.type,
        body: payload.body,
    })
}

export async function getGroupDetail(payload) {
    return request(`${format(api.getGroupDetail.url, {id: payload.id})}`)
}

// 获取群分组
export async function getGroupGrouping() {
    return request(api.getGroupGrouping.url)
}

// 群
export async function chatGroupsSearch(payload) {
    return request(api.chatGroupsSearch.url, {
        method: api.chatGroupsSearch.type,
        body: payload.body,
    })
}
